(function authServiceDefinition() {
    'use strict';

    angular.module("Auth")
        .provider('auth', ['configProvider', function (configProvider) {
            var clientId = 'web',
                organizationId = null,
                identityChangedCallbacks = [],
                unauthorizedListeners = [],
                refreshUrl = null,
                loginUrl = null,
                logoutUrl = null,
                authApiName = null;

            this.setRefreshUrl = function setRefreshUrl(url) {
                refreshUrl = url;
            };

            this.setLoginUrl = function setLoginUrl(url) {
                loginUrl = url;
            };

            this.setLogoutUrl = function setLogoutUrl(url) {
                logoutUrl = url;
            };

            this.setClientId = function setClientId(id) {
                clientId = id;
            };

            this.setOrganizationId = function setOrganizationId(id) {
                organizationId = id;
            };

            this.setAuthApiName = function setAuthApiName(name) {
                authApiName = name;
            };

            function onIdentityChanged(callback) {
                identityChangedCallbacks.push(callback);
            };

            this.onIdentityChanged = onIdentityChanged;

            function offIdentityChanged(callback) {
                var index = identityChangedCallbacks.indexOf(callback);

                if (index !== -1) {
                    identityChangedCallbacks.splice(index, 1);
                }
            };

            this.offIdentityChanged = offIdentityChanged;

            function onUnauthorized(callback) {
                unauthorizedListeners.push(callback);
            };

            this.onUnauthorized = onUnauthorized;

            function offUnauthorized(callback) {
                var index = unauthorizedListeners.indexOf(callback);

                if (index !== -1) {
                    unauthorizedListeners.splice(index, 1);
                }
            };

            this.offUnauthorized = offUnauthorized;

            this.$get = [
                '$injector', '$q', '$window', '$cookies', '$location', '$timeout', '$rootScope', 'config', 'storage', '$state',
                function ($injector, $q, $window, $cookies, $location, $timeout, $rootScope, config, storage, $state) {
                    refreshUrl = refreshUrl || configProvider.authUrl('/Home/DoRefresh'),
                    loginUrl = loginUrl || configProvider.authUrl('/Home/DoLogin'),
                    logoutUrl = logoutUrl || configProvider.authUrl('/Home/DoLogout');

                    // no lo puedo poner como dependencia, pues el injector depende de este servicio
                    // y se crea una dependencia circular.
                    var restUrlBuilder = authApiName ? $injector.get('restUrlBuilder')(authApiName) : $injector.get('restUrlBuilder');
                    var $http = $injector.get('$http');

                    var identity = null, // información de identidad
                        roles = null, // Roles del usuario
                        serviceObject = null;

                    var tokenRefreshPromise = null; // mientras se realiza un refresh, esta variable contendrá la promesa.
                    function identityChanged(cached) {
                        for (var i = 0; i < identityChangedCallbacks.length; i++)
                            $injector.invoke(identityChangedCallbacks[i], serviceObject, { cached: cached });
                    }

                    function unauthorized() {
                        for (var i = 0; i < unauthorizedListeners.length; i++)
                            $injector.invoke(unauthorizedListeners[i], serviceObject);
                    }

                    function clearIdentity() {
                        if (identity != null) {
                            identity = null;
                            roles = null;
                            storage.removeFromAll('identity');
                            identityChanged();
                        }
                    }

                    function setIdentity(iden, cached) {
                        identity = iden;
                        roles = iden.roles.split(',');
                        if (!cached) {
                            storage.removeFromAll('identity');
                            if (iden.rememberMe)
                                storage.Local.store('identity', iden);
                            else
                                storage.Session.store('identity', iden);
                        }
                        identityChanged(cached);
                    }

                    // El login y refresh lo manejo con mi servidor, pues manda el client_id y el secret
                    function processExternalLogin(token) {
                        if (token.isError) {
                            // tiene {key, value}
                            if (token.key === 'user_not_confirmed') {
                                $state.go('confirm-mail', {
                                    code: token.value,
                                    resend: true
                                });
                            } else {
                                token.show('LoginFormExternalError');
                            }
                        } else if (token.redirectState) {
                            $state.go(token.redirectState, token.redirectParams);
                        } else if (token.registered) {
                            // si está registrado seteo la identidad.
                            setIdentity(token);
                        } else {
                            $timeout(function () {
                                // muestro la pantalla de registro externo
                                storage.Session.store('External', angular.copy(token));

                                if (serviceObject.externalRegistrationCallback)
                                    serviceObject.externalRegistrationCallback();
                            }, 100);
                        }
                    }

                    serviceObject = {
                        sessionLost: function () {
                            unauthorized();
                        },
                        externalRegistrationCallback: null,
                        onIdentityChanged: onIdentityChanged,
                        offIdentityChanged: offIdentityChanged,
                        forget: function forget() {
                            if (this.remembered())
                                clearIdentity();
                        },
                        getToken: function getToken() {
                            if (identity)
                                return identity.access_token;
                            return null;
                        },
                        ensureToken: function ensureToken() {
                            if (identity !== null && this.willExpire(0)) {
                                return this.refreshToken();
                            }
                            return $q.when(true);
                        },
                        isLogged: function isLogged() {
                            return (identity !== null);
                        },
                        isExternal: function isExternal() {
                            return (identity && identity.external === true);
                        },
                        setHeader: function setHeader(configuration) {
                            configuration.headers = configuration.headers || {};
                            if (identity) {
                                configuration.headers.Authorization = 'Bearer ' + identity.access_token;
                            }
                            if (organizationId)
                                configuration.headers.Organization = organizationId;
                        },
                        willExpire: function willExpire(minutes) {
                            if (identity === null) {
                                return true;
                            }
                            var expiration = new Date(identity['.expires']);
                            var now = new Date();
                            now = new Date(now.getTime() + minutes * 60000);
                            return expiration < now;
                        },
                        getUserName: function getUserName() {
                            if (identity)
                                return identity.userName;
                            return null;
                        },
                        getUserNick: function getUserNick() {
                            if (identity)
                                return identity.userNick;
                            return null;
                        },
                        getData: function getData(key) {
                            if (identity)
                                return identity[key];

                            return null;
                        },
                        getRoles: function getRoles() {
                            if (identity)
                                return roles;
                            return null;
                        },
                        isInRole: function isInRole(role) {
                            if (identity)
                                return roles.indexOf(role) !== -1;
                            return null;
                        },
                        getResources: function getResources() {
                            if (identity)
                                return identity.resources;
                            return null;
                        },
                        refreshToken: function refreshToken() {
                            if (identity == null)
                                return $q.when(false, {});

                            // si ya hay un refresh en curso, retorno la misma promesa
                            // para no repetir el refresh
                            if (tokenRefreshPromise)
                                return tokenRefreshPromise;

                            // El refresh lo hace la página por el client id
                            var deferred = $q.defer();
                            tokenRefreshPromise = deferred.promise;

                            if (identity.implicit) { // el implicit flow no posee refresh token
                                deferred.reject(false);
                                return deferred.promise;
                            }

                            // no lo puedo poner como dependencia, pues el injector depende de este servicio
                            // y se crea una dependencia circular.
                            $http.post(refreshUrl, '', { withCredentials: true })
                                .then(function (response) {
                                    if (response.status === 200 && typeof (response.data) !== 'string') {
                                        tokenRefreshPromise = null;
                                        setIdentity(response.data);
                                        deferred.resolve(true, null);
                                    } else {
                                        tokenRefreshPromise = null;
                                        clearIdentity();
                                        this.sessionLost();
                                        deferred.reject(false, response.data);
                                    }
                                }.bind(this),
                                function (response) {
                                    tokenRefreshPromise = null;
                                    clearIdentity();
                                    this.sessionLost();
                                    deferred.reject(response.data);
                                }.bind(this));

                            return deferred.promise;
                        },

                        changeApp: function changeApp(t) {
                            var integrated = false;

                            var postData = {
                                token: t
                            };

                            var deferred = $q.defer();

                            $http.post('/Home/DoChangeApp', postData, { withCredentials: true })
                                .then(function (response) {
                                        var data = response.data;

                                        if (response.status === 200 && typeof (data) !== 'string') {
                                            setIdentity(data);
                                            deferred.resolve(true);
                                        } else {
                                            clearIdentity();

                                            if (data) {
                                                if (data.error === 'user_not_confirmed') {
                                                    data = {
                                                        notConfirmed: true,
                                                        code: data.error_description
                                                    };
                                                } else if (data.error === 'locked_out') {
                                                    data = {
                                                        isLockedOut: true,
                                                        lockoutTime: parseInt(data.error_description)
                                                    };
                                                } else if (data.error === 'locked_out_self_management') {
                                                    data = {
                                                        isLockedOutSelfManagement: true
                                                    };
                                                } else if (data.error === 'disabled') {
                                                    data = {
                                                        disabled: true
                                                    };
                                                }
                                            }

                                            deferred.reject(data || {});
                                        }
                                    },
                                    function (response) {
                                        clearIdentity();
                                        var data = response.data;
                                        if (data) {
                                            if (data.error === 'user_not_confirmed') {
                                                data = {
                                                    notConfirmed: true,
                                                    code: data.error_description
                                                };
                                            } else if (data.error === 'locked_out') {
                                                data = {
                                                    isLockedOut: true,
                                                    lockoutTime: parseInt(data.error_description)
                                                };
                                            } else if (data.error === 'locked_out_self_management') {
                                                data = {
                                                    isLockedOut: true
                                                };
                                            } else if (data.error === 'disabled') {
                                                data = {
                                                    disabled: true
                                                };
                                            }
                                        }

                                        deferred.reject(data || {});
                                    });

                            return deferred.promise;
                        },

                        // Modalidades de logueo disponibles. Por defecto se tuilizará "Normal"
                        LoginModes: {
                            Normal: 0,
                            Integrated: 1,
                            Delegated: 2
                        },
                        // Loguea al usuario con autenticación integrada. (tiene que estar habilitada en la aplicación Web)
                        loginIntegrated: function () {
                            /*
                            NOTA: cuando se ingresa con autenticación integrada no permito utilizar el "Recordarme",
                            ya que sino podría suceder que otro usuario corra el IE con Run As y el token siga siendo el del usuario anterior.
                            Quizas se pueda habilitar pero habría que tenerlo en cuenta en los controllers, etc.
                            */
                            return this.login(null, null, false, this.LoginModes.Integrated);
                        },
                        // Loguea al usuario con autenticación delegada.
                        loginDelegatedd: function (username, password, rememberMe) {
                            return this.login(username, password, rememberMe, this.LoginModes.Delegated);
                        },
                        login: function login(username, password, rememberMe, loginMode, otp) {
                            var integrated = false;

                            if (loginMode && loginMode !== this.LoginModes.Normal) {
                                integrated = true;
                            }

                            rememberMe = (rememberMe || false) && !integrated;

                            /*
                            NOTA: cuando se ingresa con autenticación integrada no permito utilizar el "Recordarme",
                            ya que sino podría suceder que otro usuario corra el IE con Run As y el token siga siendo el del usuario anterior.
                            Quizas se pueda habilitar pero habría que tenerlo en cuenta en los controllers, etc.
                            */

                            var postData = {
                                userName: username,
                                password: password,
                                rememberMe: rememberMe,
                                integrated: integrated,
                                otp: otp != null ? true : false, 
                            };
                            if (otp != null) {
                                postData.password = postData.password + ";" + otp;
                            }
                            var deferred = $q.defer();

                            // no lo puedo poner como dependencia, pues el injector depende de este servicio
                            // y se crea una dependencia circular.
                            $http.post(loginUrl, postData, { withCredentials: true })
                                .then(function (response) {
                                    var data = response.data;

                                    if (response.status === 200 && typeof (data) !== 'string') {
                                        setIdentity(data);
                                        deferred.resolve(true);
                                    } else {
                                        clearIdentity();

                                        if (data) {
                                            if (data.error === 'user_not_confirmed') {
                                                data = {
                                                    notConfirmed: true,
                                                    code: data.error_description
                                                };
                                            } else if (data.error === 'locked_out') {
                                                data = {
                                                    isLockedOut: true,
                                                    lockoutTime: parseInt(data.error_description)
                                                };
                                            } else if (data.error === 'locked_out_self_management') {
                                                data = {
                                                    isLockedOutSelfManagement: true
                                                };
                                            } else if (data.error === 'disabled') {
                                                data = {
                                                    disabled: true
                                                };
                                            }
                                        }

                                        deferred.reject(data || {});
                                    }
                                },
                                function (response) {
                                    clearIdentity();
                                    var data = response.data;
                                    if (data) {
                                        if (data.error === 'user_not_confirmed') {
                                            data = {
                                                notConfirmed: true,
                                                code: data.error_description
                                            };
                                        } else if (data.error === 'locked_out') {
                                            data = {
                                                isLockedOut: true,
                                                lockoutTime: parseInt(data.error_description)
                                            };
                                        } else if (data.error === 'locked_out_self_management') {
                                            data = {
                                                isLockedOut: true                                            };
                                        } else if (data.error === 'disabled') {
                                            data = {
                                                disabled: true
                                            };
                                        }
                                    }

                                    deferred.reject(data || {});
                                });

                            return deferred.promise;
                        },
                        logout: function logout() {
                            if (identity == null) {
                                return $q.when(true);
                            }

                            var postData = {
                                accessToken: identity.access_token
                            };

                            var deferred = $q.defer();
                            $http.post(logoutUrl, postData, { withCredentials: true })
                                .then(function () {
                                    clearIdentity();
                                    deferred.resolve(true);
                                },
                                    function () {
                                        deferred.resolve(false);
                                    });
                            return deferred.promise;
                        },
                        remembered: function remembered() {
                            return (identity !== null && identity.rememberMe);
                        },
                        // esta funcion obtendrá los proveedores externos
                        // y retornará una promesa a los mismos.
                        getExternalProviders: function getExternalProviders(returnUrl, getCode, forCurrentUser) {
                            if (getCode === undefined)
                                getCode = true;

                            return restUrlBuilder.all('Account')
                                .all('externalLogins')
                                .get({
                                    params: {
                                        returnUrl: returnUrl,
                                        generateState: true,
                                        getCode: ((getCode & !forCurrentUser) ? 'true' : 'false'),
                                        forClient: clientId,
                                        forCurrentUser: forCurrentUser
                                    }
                                });
                        },
                        // login with external provider
                        // Al finalizar, se deberá invocar a top.authenticated(success, result);
                        loginWithProvider: function loginWithProvider(provider, rememberMe, useWindow) {
                            if (rememberMe)
                                storage.Session.store('remember', rememberMe);

                            var deferred = $q.defer();

                            if (useWindow) {
                                var popup = window.open(config.externalProviderUrl(provider.url), 'auth', "width=1024, height=640, toolbar:no");

                                if (popup) {
                                    window.authenticated = function popupAuthenticated(success, result) {
                                        $rootScope.$apply(function () {
                                            deferred.promise.then(function () {
                                                popup.close();
                                            }, function () {
                                                popup.close();
                                            });

                                            if (success) {
                                                processExternalLogin(result);
                                                deferred.resolve(true);
                                            } else {
                                                deferred.reject(result);
                                            }
                                        });
                                    }.bind(window);
                                } else {
                                    deferred.reject();
                                }
                            } else {
                                $window.location.replace(config.externalProviderUrl(provider.url));
                            }
                            return deferred.promise;
                        },
                        // add external provider to logged user
                        // Al finalizar, se deberá invocar a top.authenticated(success, result);
                        addLoginProvider: function addLoginProvider(provider, useWindow) {
                            if (!this.isLogged())
                                return $q.reject();

                            var deferred = $q.defer();

                            if (useWindow) {
                                var popup = window.open(config.externalProviderUrl(provider.url), 'auth', "width=1024, height=640, toolbar:no");

                                if (popup) {
                                    window.authenticated = function popupAuthenticated(success, result) {
                                        $rootScope.$apply(function () {
                                            deferred.promise.then(function () {
                                                popup.close();
                                            }, function () {
                                                popup.close();
                                            });

                                            if (success) {
                                                // invoco al add de la api
                                                restUrlBuilder.all('Account')
                                                    .custom('AddExternalLogin')
                                                    .post({
                                                        externalAccessToken: result.access_token
                                                    })
                                                    .then(function () {
                                                        deferred.resolve(true);
                                                    }, function (error) {
                                                        deferred.reject(error);
                                                    });
                                            } else {
                                                deferred.reject(result);
                                            }
                                        });
                                    }.bind(window);
                                } else {
                                    deferred.reject();
                                }
                            } else {
                                storage.Session.store('ReturnState', {
                                    state: $state.$current.name,
                                    params: $state.params
                                });
                                $window.location.replace(config.externalProviderUrl(provider.url));
                            }
                            return deferred.promise;
                        },
                        register: function register(regserviceObject) {
                            var deferred = $q.defer();

                            var postData = JSON.stringify(regserviceObject);

                            restUrlBuilder.all('Account')
                                .custom('register')
                                .post(postData, {
                                    headers: { "Content-Type": "application/json" }
                                })
                                .then(function (data) {
                                    deferred.resolve(data);
                                }, function (error) {
                                    deferred.reject(error);
                                });

                            return deferred.promise;
                        },
                        registerExternal: function registerExternal(regserviceObject) {
                            var deferred = $q.defer();

                            var postData = JSON.stringify(regserviceObject);

                            // no lo puedo poner como dependencia, pues el injector depende de este servicio
                            // y se crea una dependencia circular.
                            restUrlBuilder.all('Account')
                                .custom('RegisterExternal')
                                .post(postData, {
                                    headers: {
                                        "Content-Type": "application/json",
                                        "Authorization": "Bearer " + this.externalInfo().access_token
                                    }
                                })
                                .then(function (data) {
                                    deferred.resolve(data);
                                },
                                    function (error) {
                                        deferred.reject(error);
                                    });

                            return deferred.promise;
                        },
                        externalInfo: function externalInfo() {
                            return storage.Session.getItem('External');
                        },
                        resetExternalInfo: function resetExternalInfo() {
                            storage.Session.remove('External');
                        },
                        checkLogin: function checkLogin(login) {
                            var deferred = $q.defer();

                            restUrlBuilder.all('Account')
                                .custom('CheckLogin')
                                .get({
                                    params: { login: login }
                                })
                                .then(function registerControllerCheckLoginOk() {
                                    deferred.resolve(true);
                                },
                                    function registerControllerCheckLoginError(result) {
                                        if (result.status === 404) {
                                            deferred.resolve(false);
                                        } else {
                                            deferred.reject();
                                        }
                                    });

                            return deferred.promise;
                        },

                        createTokenChangeApp: function createTokenChangeApp() {
                            var deferred = $q.defer();

                            restUrlBuilder.all('AppSwitch').post({})
                                .then(function createTokenChangeAppOk(result) {
                                        deferred.resolve(result);
                                    },
                                function createTokenChangeAppError(error) {
                                    deferred.reject(error);
                                    });
                            return deferred.promise;
                        },



                        confirmMail: function authconfirmMail(code) {
                            if (code == null)
                                return $q.reject();

                            var deferred = $q.defer();

                            restUrlBuilder.all('Account')
                                .custom('ConfirmEmail')
                                .get({
                                    params: { code: code }
                                })
                                .then(function () {
                                    deferred.resolve(true);
                                }, function (error) {
                                    deferred.reject(error);
                                });
                            return deferred.promise;
                        },
                        confirmMailChange: function authConfirmMailChange(code) {
                            if (code == null)
                                return $q.reject();

                            var deferred = $q.defer();

                            restUrlBuilder.all('Account')
                                .custom('ConfirmEmailChange')
                                .get({
                                    params: { code: code }
                                })
                                .then(function ok() {
                                    deferred.resolve();
                                },
                                    function error(data) {
                                        deferred.reject(data);
                                    });
                            return deferred.promise;
                        },
                        resendConfirmation: function confirmMail(code, mailConfirmationUrl) {
                            if (code == null || mailConfirmationUrl == null)
                                return $q.reject();

                            var deferred = $q.defer();

                            restUrlBuilder.all('Account')
                                .custom('ResendConfirmation')
                                .get({
                                    params: {
                                        code: code,
                                        mailConfirmationUrl: mailConfirmationUrl
                                    }
                                })
                                .then(function () {
                                    deferred.resolve();
                                },
                                    function (error) {
                                        deferred.reject(error);
                                    });
                            return deferred.promise;
                        },
                        forgotPassword: function forgotPassword(userLogin, callbackUrl, appId) {
                            if (userLogin == null || callbackUrl == null)
                                return $q.reject();

                            var deferred = $q.defer();

                            restUrlBuilder.all('Account')
                                .custom('ForgotPassword')
                                .get({
                                    params: {
                                        userName: userLogin,
                                        callbackUrl: callbackUrl,
                                        appId: appId
                                    }
                                })
                                .then(function () {
                                    deferred.resolve();
                                },
                                    function (error) {
                                        deferred.reject(error);
                                    });

                            return deferred.promise;
                        },
                        resetPassword: function resetPassword(resetPwdModel) {
                            if (resetPwdModel == null || resetPwdModel.code == null
                                || resetPwdModel.password == null || resetPwdModel.confirmPassword == null)
                                return $q.reject();

                            var deferred = $q.defer();

                            var postData = JSON.stringify(resetPwdModel);

                            restUrlBuilder.all('Account')
                                .custom('ResetPassword')
                                .post(postData) // headers: { "Content-Type": "application/json" }
                                .then(function () {
                                    deferred.resolve();
                                }, function (error) {
                                    deferred.reject(error);
                                });

                            return deferred.promise;
                        },

                        generateOtp: function resetOtp(params) {
                            if (params == null || params.userName == null || params.callbackUrl == null)
                                return $q.reject();

                            var deferred = $q.defer();

                            restUrlBuilder.all('UserOtps')
                                .custom('GenerateOTP')
                                .get({
                                    params: {
                                        userName: params.userName,
                                        callbackUrl: params.callbackUrl,
                                        appId: params.appId
                                    }
                                })
                                .then(function () {
                                    deferred.resolve();
                                },
                                function (error) {
                                    deferred.reject(error);
                                });

                            return deferred.promise;
                        },

                        removeLogin: function removeLogin(provider) {
                            if (provider == null)
                                return $q.reject();

                            var deferred = $q.defer();

                            restUrlBuilder.all('Account')
                                .custom('RemoveLogin')
                                .post(provider)
                                .then(function () {
                                    deferred.resolve(true);
                                }, function (error) {
                                    deferred.reject(error);
                                });

                            return deferred.promise;
                        },
                        // Esta función permite recordar a un usuario de forma tal
                        // que al hacer un redirect y volver a la página se recuerde el usuario.
                        rememberUserForCallback: function rememberUserForCallback() {
                            if (!identity.rememberMe) {
                                identity.rememberedCB = true;
                            }
                        }
                    };

                    // si hay un access token es por un login externo (en la misma window y no en iframe).
                    if ($cookies.tk) {
                        var token = angular.fromJson($cookies.tk);
                        delete $cookies['tk'];

                        processExternalLogin(token);
                    }

                    if (window.location.hash) {
                        var obj = parseQuery(decodeURIComponent(window.location.hash.substr(1)));

                        if (obj.access_token) {
                            // si vino por hash es porque no fue obtenida por code y es
                            // un implicit grant, por ende no posee refresh token.
                            token.implicit = true;

                            var returnState = storage.Session.getItem('ReturnState');

                            // guardo el token
                            if (returnState) {
                                // invoco al add de la api
                                restUrlBuilder.all('Account')
                                    .custom('AddExternalLogin')
                                    .post({
                                        externalAccessToken: obj.access_token
                                    })
                                    .then(function () {
                                        $state.go(returnState.state, returnState.params);
                                    }, function (error) {
                                        returnState.params.error = error;
                                        $state.go(returnState.state, returnState.params);
                                    });
                            }
                        }
                    }

                    var item = storage.Session.getItem('identity');

                    if (item != null) {
                        setIdentity(item, true);
                    } else {
                        item = storage.Local.getItem('identity');

                        if (item != null) {
                            var now = new Date();
                            var expiration = new Date(item['.expires']);

                            if (expiration > now || item.rememberMe) {
                                storage.Local.remove('identity');
                                setIdentity(item, true);
                            }
                        }
                    }

                    return serviceObject;
                }
            ];
        }]);
})();
